import {useQuery} from "@tanstack/react-query";
import getSevenDaysLeaderboard from "../api/getSevenDaysLeaderboard";

const useGetSevenDaysLeaderboard = () => {
  const {
    data: dataSevenDaysLeaderboard,
    isLoading: sevenDaysLeaderboardIsLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["getSevenDaysLeaderboard"],
    queryFn: getSevenDaysLeaderboard,
  });

  return {
    sevenDaysLeaderboardIsLoading,
    dataSevenDaysLeaderboard,
    isError,
    error,
  };
};

export default useGetSevenDaysLeaderboard;
